import React from "react";
import Navigation from "../Shared/Navigation/Navigation";

const Blogs = () => {
  return (
    <div>
      <Navigation className="bg-transparent"></Navigation>
      <h1>blogs comming soon</h1>
    </div>
  );
};

export default Blogs;
